import React from "react";
import MobileSliderPagesCloseButton, {
    IMobileSliderPagesCloseButtonProps,
} from './MobileSliderPagesCloseButton/MobileSliderPagesCloseButton';
import {
    MobileSliderPagesHeaderCloseButtonContainerStyled,
    MobileSliderPagesHeaderContentStyled,
    MobileSliderPagesHeaderStyled
} from "./styled/MobileSliderPagesStyled";

type IMobileSliderPagesHeaderProps = IMobileSliderPagesCloseButtonProps & {
    children?: JSX.Element | JSX.Element[] | string;
    hideCloseButton?: boolean;
    hasRightComponent?: boolean;
    onClick?: () => void;
}

function MobileSliderPagesHeader(props: IMobileSliderPagesHeaderProps) {
    const { children, hideCloseButton, hasRightComponent, className, ...rest } = props;
    return <MobileSliderPagesHeaderStyled className={className}>
        {hideCloseButton !== true && (
            <MobileSliderPagesHeaderCloseButtonContainerStyled>
                <MobileSliderPagesCloseButton {...rest} />
            </MobileSliderPagesHeaderCloseButtonContainerStyled>
        )}
        <MobileSliderPagesHeaderContentStyled style={{
            marginRight: (hideCloseButton !== true && !hasRightComponent) ? '40px' : '0',
        }}>
            {children}
        </MobileSliderPagesHeaderContentStyled>
    </MobileSliderPagesHeaderStyled>
}

export default MobileSliderPagesHeader;
